const defaultSchedulData = [
	{ id: 1, days: "Domingo", beginTime: "", endTime: "" },
	{ id: 2, days: "Lunes", beginTime: "", endTime: "" },
	{ id: 3, days: "Martes", beginTime: "", endTime: "" },
	{ id: 4, days: "Miércoles", beginTime: "", endTime: "" },
	{ id: 5, days: "Jueves", beginTime: "", endTime: "" },
	{ id: 6, days: "Viernes", beginTime: "", endTime: "" },
	{ id: 7, days: "Sábado", beginTime: "", endTime: "" },
];

export default defaultSchedulData;
